export const setAdmin = (isAdmin) => {
    return {
        type: 'SET_ADMIN',
        isAdmin
    }
};
